import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import 'aos/dist/aos.css';
import AOS from 'aos';
import '@fortawesome/fontawesome-free/css/all.css';


AOS.init();

// createApp(App).mount('#app');
createApp(App).use(router).mount("#app");


